export const NODE_SECTIONS = {
  DESC_BOTTOM: 'nodeDescBottom',
  DESC_FOOTER: 'nodeDescFooter',
  TITLE: 'title',
};
